import React, {useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {format, toDate, lightFormat, endOfMonth} from 'date-fns';
import useOutsideClick from '../../../../../../../../hooks/use-outside-click/lib/useOutsideClick';
import {getLoyaltyDashboardData} from '../../../../../store/actions/thunk';

import * as S from './SelectMonth.styles';

const SelectMonth = ({data, setData, monthToShow}) => {
  const dispatch = useDispatch();

  const listRef = useRef();
  const [toggle, setToggle] = useState(false);
  const date = new Date();
  let month = date.getMonth();
  // if (month < 10) month = month + 10; //needed to be changed later
  //  const [selectedVal, setSelectedVal] = useState(data[month - 10]);
  const [selectedVal, setSelectedVal] = useState(data[month]);

  const handleMonth = () => {
    setToggle(!toggle);
  };
  const handleSelect = val => {
    let idx = data.findIndex(item => item === val?.name);

    dispatch(getLoyaltyDashboardData(idx + 1, false, successCallback, errorCallback));
    setSelectedVal(val?.name);
    setToggle(false);
  };

  useOutsideClick(listRef, () => {
    if (toggle) {
      setToggle(false);
    }
  });

  const successCallback = data => {
    if (data?.completed) {
      for (let completedTravel = 0; completedTravel < data.completed.length; completedTravel++) {
        let travelDay = new Date(
          data.completed[completedTravel].travelStartDate,
        ).toLocaleDateString('en-US');
        //console.log(day);
        data.completed[completedTravel].travelStartDate = travelDay;
        let bookingDay = new Date(data.completed[completedTravel].bookingDate).toLocaleDateString(
          'en-US',
        );
        data.completed[completedTravel].bookingDate = bookingDay;
      }
    }
    if (data?.upcoming) {
      for (let upcomingTravel = 0; upcomingTravel < data.upcoming.length; upcomingTravel++) {
        let travelDay = new Date(data.upcoming[upcomingTravel].travelStartDate).toLocaleDateString(
          'en-US',
        );
        //console.log(day);
        data.upcoming[upcomingTravel].travelStartDate = travelDay;
        let bookingDay = new Date(data.upcoming[upcomingTravel].bookingDate).toLocaleDateString(
          'en-US',
        );
        data.upcoming[upcomingTravel].bookingDate = bookingDay;
      }
    }
    if (data?.incentive) {
      for (let incentiveCounter = 0; incentiveCounter < data.incentive.length; incentiveCounter++) {
        let travelDay = new Date(data.incentive[incentiveCounter].creditDate).toLocaleDateString(
          'en-US',
        );
        //console.log(day);
        data.incentive[incentiveCounter].creditDate = travelDay;
      }
    }
    setData(data);
    //setData(data);
  };

  const errorCallback = data => {
    console.log(data);
  };

  return (
    <S.SlctMnthCnt>
      <S.SlctMnth onClick={handleMonth}>
        <S.SlctMnthVal>{selectedVal}</S.SlctMnthVal>
      </S.SlctMnth>
      {toggle && (
        <S.SlctMnthList ref={listRef}>
          {monthToShow.map((item, index) => (
            <S.SlctMnthListItm onClick={() => handleSelect(item)} key={index}>
              {item?.name}
            </S.SlctMnthListItm>
          ))}
        </S.SlctMnthList>
      )}
    </S.SlctMnthCnt>
  );
};

export default SelectMonth;
